
export interface IOrgVehiclesNRFCRequest {
    orgId: number;
    nrfcStatus: number;    
}

export class OrgVehiclesNRFCRequest implements IOrgVehiclesNRFCRequest {
    orgId: number;
    nrfcStatus: number = 0;    
}